import { unionWith } from "lodash";

import * as actions from "./actiontypes";
import { CustomMedicalTypeAction } from "./actions";
import { CustomMedicalType } from "./models";

export function customMedicalTypes(state: CustomMedicalType[] | null = null, action: CustomMedicalTypeAction): CustomMedicalType[] | null {
    switch (action.type) {
        case actions.LOAD_CUSTOM_MEDICAL_TYPES_SUCCESS:
            return unionWith(state ?? [], action.payload, (a, b) => a.id === b.id);
        case actions.CREATE_CUSTOM_MEDICAL_TYPE_SUCCESS:
            return [...(state ?? []), action.payload];
        default:
            return state;
    }
}
